/* ============================================================
   Ürün galerisi — video kareleri
   theme.js galerideki görseli değiştirir ve aktif karenin sırasını
   [data-gallery-main] üzerindeki data-gallery-index niteliğine yazar.
   Bu dosya o niteliği izler: aktif kare videoysa videoyu <template>'ten
   basıp sessiz ve döngüde oynatır, başka kareye geçilince DOM'dan kaldırır.
   Sadece videosu olan ürünlerde yüklenir (snippets/gallery-video.liquid).
============================================================ */
(function () {
  'use strict';

  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="m16 9 5 6m0-6-5 6"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function soundButton(video) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product__video-sound';
    function sync() {
      btn.innerHTML = video.muted ? ICON_MUTED : ICON_SOUND;
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }
    btn.addEventListener('click', function () { video.muted = !video.muted; sync(); });
    sync();
    return btn;
  }

  function setup(g) {
    var main = g.querySelector('[data-gallery-main]');
    var templates = g.querySelectorAll('template[data-gallery-video]');
    if (!main || !templates.length || g._videoBound) return;
    g._videoBound = true;
    var stage = main.parentNode;
    var layer = null;
    var current = null;

    // Lightbox'ta video kapak resimleri gösterilmesin. theme.js büyüteci
    // g._images[aktif sıra] ile açar, ileri/geri de bu dizide döner. Aktif kare
    // hiçbir zaman video değil (büyüteç o sırada gizli). Bu yüzden dizide sadece
    // görselleri bırakıp, aktif görsel theme.js'in bakacağı sıraya denk gelecek
    // şekilde döndürüyoruz; video galerinin herhangi bir yerinde olabilir.
    var videoAt = {};
    Array.prototype.forEach.call(templates, function (t) { videoAt[t.getAttribute('data-gallery-video')] = true; });
    var allItems = null;
    g.addEventListener('click', function (e) {
      if (!g._images || !e.target.closest('[data-gallery-open]')) return;
      allItems = allItems || g._images;
      var idx = parseInt(main.getAttribute('data-gallery-index') || '0', 10);
      var stills = [];
      var current = 0;
      allItems.forEach(function (item, k) {
        if (videoAt[k]) return;
        if (k === idx) current = stills.length;
        stills.push(item);
      });
      var n = stills.length;
      if (!n) return;
      var shift = ((current - idx) % n + n) % n;
      g._images = stills.map(function (_, k) { return stills[(k + shift) % n]; });
    }, true);

    function stop() {
      if (!layer) return;
      layer.hidden = true;
      layer.innerHTML = ''; // video DOM'dan çıkınca durur, indirmesi de kesilir
      g.classList.remove('is-video-active');
    }

    function start(tpl) {
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'product__video-layer';
        stage.appendChild(layer);
      }
      var frag = tpl.content.cloneNode(true);
      var video = frag.querySelector('video');
      if (video) {
        // DOM'a girmeden ayarla: mobilde otomatik oynatma için sessiz + satır içi şart
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.controls = reduceMotion;
        if (reduceMotion) video.removeAttribute('autoplay');
      }
      layer.innerHTML = '';
      layer.appendChild(frag);
      layer.hidden = false;
      g.classList.add('is-video-active');
      if (!video || reduceMotion) return; // YouTube/Vimeo iframe kendi oynatır
      layer.appendChild(soundButton(video));
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {
        // Sayfa arka plan sekmesinde açıldıysa (Ctrl+tık vb.) tarayıcı otomatik
        // oynatmayı bekletir: sekme görünür olunca bir kez daha dene
        if (document.hidden) {
          document.addEventListener('visibilitychange', function retry() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', retry);
            if (!video.isConnected) return;
            var again = video.play();
            if (again && again.catch) again.catch(function () { video.controls = true; });
          });
          return;
        }
        video.controls = true; // tarayıcı engellerse oynat butonu çıksın
      });
    }

    function sync() {
      var idx = main.getAttribute('data-gallery-index') || '0';
      if (idx === current) return;
      current = idx;
      var tpl = g.querySelector('template[data-gallery-video="' + idx + '"]');
      if (tpl) start(tpl); else stop();
    }

    new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['data-gallery-index'] });
    sync();

    // Galeri ekrandan çıkınca videoyu duraklat, geri gelince sürdür
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var video = layer && !layer.hidden && layer.querySelector('video');
        if (!video || video.controls) return;
        if (entries[0].isIntersecting) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      }).observe(stage);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
